import { render, staticRenderFns } from "./ValidationPage.vue?vue&type=template&id=f52dd2f8&scoped=true&"
import script from "./ValidationPage.vue?vue&type=script&lang=js&"
export * from "./ValidationPage.vue?vue&type=script&lang=js&"
import style0 from "./ValidationPage.vue?vue&type=style&index=0&id=f52dd2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52dd2f8",
  null
  
)

export default component.exports